export default function formatCurrency(
    number: number,
    locale: string | null = null
) {
    if (locale === null) {
        locale = document.documentElement.lang;
    }

    // @ts-expect-error
    const currency = window.Shopify?.currency?.active ?? "EUR";

    return number.toLocaleString(locale, {
        style: "currency",
        currency,
    });
}
